/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CommandHandlerResponseDtoBase
 * auto generated base class for the model CommandHandlerResponseDtoModel.
 */
export const CommandHandlerResponseDtoModelBase = ModelBase
  .named('CommandHandlerResponseDto')
  .props({
    __typename: types.optional(types.literal("CommandHandlerResponseDto"), "CommandHandlerResponseDto"),
    success: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CommandHandlerResponseDtoModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
}
export function selectFromCommandHandlerResponseDto() {
  return new CommandHandlerResponseDtoModelSelector()
}

export const commandHandlerResponseDtoModelPrimitives = selectFromCommandHandlerResponseDto().success
